import * as React from "react";
import {
  Icon,
  Pivot,
  PivotItem,
  ComboBox,
  IComboBox,
  IComboBoxOption,
} from "@fluentui/react";
import { getTheme } from "@fluentui/react/lib/Styling";
import {
  initializeIcons,
  ThemeProvider,
  DefaultButton,
  SelectionMode,
  TooltipHost,
  mergeStyleSets,
} from "@fluentui/react";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { useState } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator";
import { SharedColors } from "@fluentui/theme";
import {
  DetailsList,
  DetailsListLayoutMode,
  IColumn,
} from "@fluentui/react/lib/DetailsList";
import {
  IDataTableDispositivoAsignado,
} from "../../Interfaces/IListaVerificacion";
import { IPersonaTablets } from "../../Interfaces/IEquipo";
import { useComboTablets } from "../../hooks/combosHooks/useComboTablets";
import { useEjecutarApis } from "../../hooks/useEjecutarApis";
import IdicadorProgress from "../../components/generic/IndicadorProgress";
import { MensajeBar } from "../../components/generic/ManejoResponseMessage/MessageBar";
import { IDispositivoActualizarFechaDevolucion } from "../../Interfaces/DispositivoAsignado/IDispositivoAsignado";
import { AsignacionEquiposPorPersona } from "./Dispositivos/AsignacionEquipos/AsignacionEquiposPorPersona";
import { PersonaCheckList } from "./CheckList/PersonaCheckList";
import { PersonaIperc } from "./Iperc/PersonaIperc";

initializeIcons();

const PivotIconCountExample: React.FunctionComponent = () => {
  const classNames = mergeStyleSets({
    iconFont: {
      padding: 0,
      fontSize: "16px",
      marginRight: 5,
    },
  });    
  const [overflow, { toggle: toggleOverflow }] = useBoolean(true);
  let { id } = useParams(); //obtiene el id de path(idpersona)
  const [dataActualizarDisp, setDataACtualizarDisp] =
    useState<IDispositivoActualizarFechaDevolucion>(null!);
  const [sendDataAsignacionTablet, setSendDataAsignacionTablet] =
    useState<IPersonaTablets>(null!);
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const [hideDialogError, { toggle: toggleHideDialogError }] = useBoolean(true);
  const [hideDialogSuccess, { toggle: toggleHideDialogSuccess }] =
    useBoolean(true);
  const [
    hideDialogActualizarFechaDevolucion,
    { toggle: toggleHideDialogActualizacionFechaDevolucion },
  ] = useBoolean(true);

  const theme = getTheme();

  var _columns_Dispositivo: IColumn[];

  const {
    tabletsCombo,
    comboBoxRefTablets,
    _onkeyUpSearchDispositivo,
    onClickComboTablets,
  } = useComboTablets();

  const {
    itemsDispositivo,
    ocultarMensaje,
    response,
    responseActualizarDevolucion,
    asignarTablets,
    isSend,
    actualizarFechaDevolución
  } = useEjecutarApis(id);


  _columns_Dispositivo = [
    {
      key: "marca",
      name: "Dispositivo",
      fieldName: "marca",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "imei",
      name: "IMEI",
      fieldName: "imei",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "serie",
      name: "Serie",
      fieldName: "serie",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "codigo",
      name: "Codigo",
      fieldName: "codigo",
      minWidth: 90,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "fechaEntrega",
      name: "Fecha Asignación",
      fieldName: "fechaEntrega",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "fechaDevolucion",
      name: "Fecha Devolución",
      fieldName: "fechaDevolucion",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "",
      minWidth: 60,
      maxWidth: 60,
      isResizable: false,
      onRender: (item: IDataTableDispositivoAsignado) => {
        if (item.fechaDevolucion == null) {
          return (
            <TooltipHost content="Devolver tablet">
              <Icon
                style={{ color: SharedColors.green10, cursor: "pointer" }}
                iconName="HorizontalTabKey"
                className={classNames.iconFont}
                onClick={() => {
                  ocultarMensaje();
                  toggleHideDialogActualizacionFechaDevolucion();
                  setDataACtualizarDisp({
                    dispositivoAsignadoId: item.dispositivoAsignadoId,
                  });
                }}
              />
            </TooltipHost>
          );
        }
      },
    },
  ];


  const _onChangeCombos = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption | undefined,
    nombre?: string
  ) => {
    if (event !== undefined) {
      if (option) {
        switch (nombre) {
          case "asigTablets":
            if (id !== undefined) {
              setSendDataAsignacionTablet({
                dispositivoId: option.key.toString(),
                personaId: id,
              });
            }
            return;
          default:
            return;
        }
      }
    }
  };

  return (
    <>
      <Pivot
        aria-label="Pivot Overflow Menu Example"
        overflowBehavior={overflow ? "menu" : "none"}
        overflowAriaLabel="more items"
      >
        <PivotItem headerText="Equipos" itemIcon="PC1" itemKey="01">
          <br />
          <AsignacionEquiposPorPersona personaId = {id} />
        </PivotItem>

        <PivotItem headerText="Tablets" itemIcon="tablet" itemKey="02">
          <br />
          <form action="">
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-lg12">
                  Seleccione Tablets
                </div>
                <div className="ms-Grid-col ms-sm4 ms-lg4">
                  <ComboBox
                    componentRef={comboBoxRefTablets}
                    onKeyUp={_onkeyUpSearchDispositivo}
                    onClick={onClickComboTablets}
                    options={tabletsCombo}
                    openOnKeyboardFocus
                    useComboBoxAsMenuWidth
                    onChange={(e, o) => {
                      _onChangeCombos(e, o, "asigTablets");
                    }}
                    allowFreeform
                    autoComplete="off"
                    calloutProps={{ directionalHintFixed: true }}
                    selectedKey={
                      sendDataAsignacionTablet
                        ? sendDataAsignacionTablet.dispositivoId
                        : ""
                    }
                  />
                </div>
                <div className="ms-Grid-col ms-sm4 ms-lg4">
                  <PrimaryButton
                    text="Asignar"
                    onClick={() => asignarTablets(sendDataAsignacionTablet)}
                    ariaLabel="textoo"
                  />
                </div>
              </div>

              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-lg12">
                  <IdicadorProgress isSend={isSend} subText="Enviando Datos" />
                  <div style={{ width: "50%" }}>
                    <MensajeBar ocultar={ocultarMensaje} response={response} />
                  </div>
                  <DetailsList
                    items={itemsDispositivo}
                    columns={_columns_Dispositivo}
                    setKey="set"
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                    selectionPreservedOnEmptyClick={true}
                    ariaLabelForSelectionColumn="Toggle selection"
                    ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                    checkButtonAriaLabel="select row"
                  />
                </div>
              </div>
              <br />
              <Dialog
                hidden={hideDialog}
                onDismiss={toggleHideDialog}
                dialogContentProps={{
                  title: "Enviando Información",
                  type: DialogType.normal,
                  subText: "Por favor espere un momento",
                }}
              >
                <ProgressIndicator barHeight={5} />
              </Dialog>

              <Dialog
                hidden={hideDialogSuccess}
                onDismiss={toggleHideDialogSuccess}
                dialogContentProps={{
                  title: "Proceso Correcto",
                  subText: "Su solicitud se procesó correctamente!",
                }}
              >
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      margin: "0 auto",
                    }}
                  >
                    <Icon
                      iconName="Accept"
                      style={{
                        color: theme.palette.themePrimary,
                      }}
                      className="ms-fontSize-42"
                    ></Icon>
                  </div>
                </div>
                <DialogFooter>
                  <PrimaryButton
                    onClick={() => {
                      toggleHideDialogSuccess();
                    }}
                    text="Aceptar"
                  />
                </DialogFooter>
              </Dialog>

              <Dialog
                hidden={hideDialogError}
                onDismiss={toggleHideDialogError}
                dialogContentProps={{
                  title: "Error en Solicitud",
                  subText: "Hubo un problema con la información enviada!",
                }}
              >
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      margin: "0 auto",
                    }}
                  >
                    <Icon
                      iconName="ErrorBadge"
                      style={{
                        color: theme.palette.redDark,
                      }}
                      className="ms-fontSize-42"
                    ></Icon>
                  </div>
                </div>
                <DialogFooter>
                  <DefaultButton
                    onClick={toggleHideDialogError}
                    text="Aceptar"
                  />
                </DialogFooter>
              </Dialog>
            </div>
          </form>
        </PivotItem>
        <PivotItem headerText="IPERC" itemIcon="ReportLibrary" itemKey="03">
           <PersonaIperc personaId={id??""}/>
       </PivotItem>
        <PivotItem headerText="CheckList"  itemIcon="ReceiptCheck" itemKey="04">
               <PersonaCheckList personaId={id??""}/>
        </PivotItem>
      </Pivot>

      <Dialog
        hidden={hideDialogActualizarFechaDevolucion}
        onDismiss={toggleHideDialogActualizacionFechaDevolucion}
        modalProps={{ isBlocking: true }}
        dialogContentProps={{
          title: "Confirmar",
          subText: "¿Quiere registrar la devolución del equipo?",
        }}
      >
        <IdicadorProgress subText="Enviado Datos" isSend={isSend} />
        <MensajeBar
          ocultar={ocultarMensaje}
          response={responseActualizarDevolucion}
        />
        <DialogFooter>
          <PrimaryButton
            onClick={() => {
              actualizarFechaDevolución(dataActualizarDisp);
            }}
            text="Registrar"
          />
          <DefaultButton
            onClick={() => {
              toggleHideDialogActualizacionFechaDevolucion();
            }}
            text="Salir"
          />
        </DialogFooter>
      </Dialog>
    </>
  );
};
const PivotIconCountExampleWrapper = () => (
  <ThemeProvider>
    <PivotIconCountExample />
  </ThemeProvider>
);

const ListaVerificacion = () => {
  return <PivotIconCountExampleWrapper />;
};

export default ListaVerificacion;
